import {ColumnDefinition} from "./common";
import {List} from "semantic-ui-react";
import * as React from "react";
import InfiniteScroll from "react-infinite-scroller";
import {TranslationFunction} from "i18next";
import {withNamespaces, WithNamespaces} from "react-i18next";
import './DataList.css';

type ListItemRenderFunction = (rowData: any, t: TranslationFunction) => any;

const DataListItem = (props: {renderItem: ListItemRenderFunction, columns: ColumnDefinition[], selectedColumns?: string[]; filter?:  { [p: string]: any }; rowData: any} & WithNamespaces) => {
  return <List.Item className="row">
    {props.renderItem(props.rowData, props.t)}
  </List.Item>;
};

const DataListItemComponent = React.memo(withNamespaces()(DataListItem));


const DataListComponent = (props: {data: any;
  page: number;
  totalPages: number;
  getScrollParent: () => any;
  loadMore: () => any;
  columns: ColumnDefinition[];
  selectedColumns?: string[];
  loading?: boolean;
  filter?:  { [p: string]: any };
  renderItem: ListItemRenderFunction;
}) => {
  if(props.data == null) {
    return null;
  }
  const dataSource = Array.isArray(props.data) ? props.data : props.data.content;
  const items = dataSource.map(function (dataRow: any, idx: number) {
    return (
      <DataListItemComponent renderItem={props.renderItem} filter={props.filter} key={idx} columns={props.columns} selectedColumns={props.selectedColumns} rowData={dataRow} />
    );
  });

  return (<InfiniteScroll
    element="div"
    pageStart={0}
    loadMore={props.loadMore}
    hasMore={props.totalPages > props.page}
    threshold={1000}
    useWindow={false}
    getScrollParent={props.getScrollParent}
  >
    <List className="infosys__data-list">
      {items}
    </List>
  </InfiniteScroll>);
};

export const DataList = React.memo(DataListComponent);